/**
 * useDashboardState — derives which dashboard layout to render.
 *
 * Pure function over (memberCount, jobCount). No persistence; the state
 * follows server data every render. The associated hook keeps the call
 * site tidy.
 */

export type DashboardState = 'empty' | 'onboarding' | 'populated';

export interface DashboardStateInputs {
  memberCount: number;
  jobCount: number;
}

export function deriveDashboardState({
  memberCount,
  jobCount,
}: DashboardStateInputs): DashboardState {
  if (memberCount === 0) return 'empty';
  if (jobCount === 0) return 'onboarding';
  return 'populated';
}

/** Convenience hook for callers that already have the two counts in scope. */
export function useDashboardState(inputs: DashboardStateInputs): DashboardState {
  return deriveDashboardState(inputs);
}
